export function getDefaultImage(): string {
	return '/images/default-petition-darker.gif';
}
